export default __webpack_public_path__ + "static/media/usa.b5934261.jpeg";